<template>
  <ac-layout-form v-if="canRender" title="申请续行" @back="back">
    <van-cell-group>
      <div class="fd-input-info">
        <div ref="jcbqjbxx">
          <van-field
            class="text-right"
            v-model="formData.cSqfymc"
            required
            clearable
            readonly
            label="选择法院"
            right-icon="arrow"
            placeholder="请选择申请法院"
            @click="selectCourtBq"
          ></van-field>
          <van-field
            v-model="formData.cAh"
            required
            clearable
            readonly
            border
            input-align="right"
            label="案号"
          ></van-field>
          <van-field-checkbox
            label="申请人"
            placeholder="请选择申请人"
            required
            readonly
            v-model="formData.cSqrxmMultiple"
            :columns="sqrList"
            :isSearch="false"
            :option="{ label: 'sqrmc', value: 'cId' }"
          />
          <van-field
            v-model="formData.cSqxbyyText"
            required
            readonly
            label="续行保全事由"
            right-icon="arrow"
            input-align="right"
            placeholder="请选择续行保全事由"
            @click="showSyPicker = true"
          ></van-field>
          <van-popup v-model="showSyPicker" position="bottom">
            <van-picker
              :columns="codeList_823000"
              show-toolbar
              :default-index="0"
              @cancel="showSyPicker = false"
              @confirm="onSyConfirm"
            >
              <template #option="option">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  {{ option.name }}
                </div>
              </template>
            </van-picker>
          </van-popup>
          <van-field
            v-model="formData.cTjrlxText"
            required
            readonly
            label="提交人身份"
            right-icon="arrow"
            input-align="right"
            placeholder="请选择提交人身份"
            @click="showTJRLX = true"
          ></van-field>
          <van-popup v-model="showTJRLX" position="bottom">
            <van-picker
              show-toolbar
              :columns="columnTJRLX"
              :default-index="0"
              @cancel="handlerPicker('showTJRLX', false)"
              @confirm="onConfirmTJRLX"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.dtCreatetime"
            readonly
            border
            input-align="right"
            label="创建申请日期"
          ></van-field>
          <van-field
            v-model="formData.cBz"
            type="textarea"
            rows="2"
            show-word-limit
            autosize
            clearable
            border
            input-align="right"
            label="备注"
            maxlength="200"
            placeholder="请输入备注"
          ></van-field>
        </div>

        <!--财产线索-->
        <div v-if="nBqlx === '1'">
          <info-title
            title-content="财产线索"
            required-description="必填"
            vertical-line="true"
          >
            <template slot="icon">
              <van-icon
                slot="right-icon"
                name="plus"
                style="line-height: inherit; float: right"
                @click="addBqCcxs"
              ></van-icon>
            </template>
          </info-title>
          <van-swipe-cell v-for="(item, index) in bqCcxsxxs" :key="item.cId">
            <van-cell
              title="财产类型"
              :value="item.cCclxText"
              :key="item.cId"
              @click="goToAddBqCCXS(item, item.cId)"
              is-link
            ></van-cell>
            <template slot="right">
              <div class="delete-btn" @click="deleteBqCCXS(item.cId, index)">
                删除
              </div>
            </template>
          </van-swipe-cell>
        </div>

        <!--证据信息-->
        <!--                                {{bqZjxx}}==={{xxbqzjxxData}}-->
        <div v-if="nBqlx === '2'">
          <info-title
            title-content="证据信息"
            required-description="必填"
            vertical-line="true"
          >
            <template slot="icon">
              <van-icon
                slot="right-icon"
                name="plus"
                style="line-height: inherit; float: right"
                @click="addBqZjxx"
              ></van-icon>
            </template>
          </info-title>
          <van-swipe-cell v-for="(item, index) in bqZjxx" :key="item.cId">
            <van-cell
              title="证据类型"
              :value="item.nZjlxTxt"
              :key="item.cId"
              @click="goToAddBqZjxx(item, item.cId)"
              is-link
            ></van-cell>
            <template slot="right">
              <div class="delete-btn" @click="deleteBqZjxx(item.cId, index)">
                删除
              </div>
            </template>
          </van-swipe-cell>
        </div>

        <!--行为信息-->
        <div v-if="nBqlx === '3'">
          <info-title
            title-content="行为信息"
            required-description="必填"
            vertical-line="true"
          >
            <template slot="icon">
              <van-icon
                slot="right-icon"
                name="plus"
                style="line-height: inherit; float: right"
                @click="addBqXwxx"
              ></van-icon>
            </template>
          </info-title>
          <!--                    {{jcbqxwxxData}}=={{bqXwxx}}-->
          <van-swipe-cell v-for="(item, index) in bqXwxx" :key="item.cId">
            <van-cell
              title="行为类型"
              :value="item.nXwbqsxTxt"
              :key="item.cId"
              @click="goToAddBqXwxx(item, item.cId)"
              is-link
            ></van-cell>
            <template slot="right">
              <div class="delete-btn" @click="deleteBqXwxx(item.cId, index)">
                删除
              </div>
            </template>
          </van-swipe-cell>
        </div>

        <info-title
          title-content="担保信息"
          required-description="非必填"
          vertical-line="true"
        >
          <template slot="icon">
            <van-icon
              slot="right-icon"
              name="plus"
              style="line-height: inherit; float: right"
              @click="addBqDbxx"
            ></van-icon>
          </template>
        </info-title>
        <van-swipe-cell v-for="(item, index) in bqDbxxs" :key="item.cId">
          <van-cell
            title="担保方式"
            :value="item.cDbfsText"
            :key="item.cId"
            @click="goToEditBqDbxx(item, item.cId)"
            is-link
          ></van-cell>
          <template slot="right">
            <div class="delete-btn" @click="deleteBqDbxx(item.cId, index)">
              删除
            </div>
          </template>
        </van-swipe-cell>
        <van-cell
          :title="dbxxzjz"
          size="large"
          style="text-align: right"
        ></van-cell>
        <Slogan theTitle="上传材料" />
        <div class="fd-upload-box">
          <van-field
            class="van-field--column van-field--no-value"
            required
            readonly
          >
            <template slot="label">
              <span>续行保全申请书</span>
            </template>
          </van-field>
          <!-- <p class="fd-com-warning-tip" v-text="mbxzts"></p> -->
          <!--                    <ac-upload-file-->
          <!--                        v-model="sqsclList"-->
          <!--                        :upload-param="uploadFileParam"-->
          <!--                        :upload-url="uploadFileUrl"-->
          <!--                        :delete-url="deleteFileUrl"-->
          <!--                        :delete-param="deleteFileParam"></ac-upload-file>-->
          <ac-upload-file
            v-model="sqsclList"
            :upload-param="uploadFileParam"
            :upload-url="uploadFileUrl"
            :get-upload-file-data="getUploadFileData"
            :delete-url="deleteFileUrl"
            :delete-param="getDeleteFileParam"
          ></ac-upload-file>
        </div>
        <div class="fd-upload-box">
          <van-field
            class="van-field--column van-field--no-value"
            readonly
            v-show="bqDbxxs.length > 0"
          >
            <template slot="label">
              <span>担保材料</span>
            </template>
          </van-field>
          <div v-for="(item, index) in sqsclListDbcl" :key="index">
            <!--                        <info-title :title-content="item.dblxmc"/>-->
            <van-field
              class="van-field--column van-field--no-value"
              readonly
              v-show="bqDbxxs.length > 0"
            >
              <template slot="label">
                <span>{{ item.dblxmc }}</span>
              </template>
            </van-field>
            <!--                        <ac-upload-file-->
            <!--                            v-model="item.clList"-->
            <!--                            :upload-param="uploadFileParamDbcl(item.dbid)"-->
            <!--                            :upload-url="uploadFileUrl"-->
            <!--                            :delete-url="deleteFileUrl"-->
            <!--                            :delete-param="deleteFileParam"></ac-upload-file>-->
            <ac-upload-file
              v-model="item.clList"
              :upload-param="uploadFileParamDbcl(item.dbid)"
              :upload-url="uploadFileUrl"
              :get-upload-file-data="getUploadFileData"
              :delete-url="deleteFileUrl"
              :delete-param="getDeleteFileParam"
            ></ac-upload-file>
          </div>
        </div>
        <div class="fd-upload-box">
          <van-field class="van-field--column van-field--no-value" readonly>
            <template slot="label">
              <span>其他材料</span>
            </template>
          </van-field>
          <!--                    <ac-upload-file-->
          <!--                        v-model="sqsclListQtcl"-->
          <!--                        :upload-param="uploadFileParamQtcl"-->
          <!--                        :upload-url="uploadFileUrl"-->
          <!--                        :delete-url="deleteFileUrl"-->
          <!--                        :delete-param="deleteFileParam"></ac-upload-file>-->
          <ac-upload-file
            v-model="sqsclListQtcl"
            :upload-param="uploadFileParamQtcl"
            :upload-url="uploadFileUrl"
            :get-upload-file-data="getUploadFileData"
            :delete-url="deleteFileUrl"
            :delete-param="getDeleteFileParam"
          ></ac-upload-file>
        </div>
      </div>
    </van-cell-group>
    <template slot="footer">
      <van-button
        class="guarantee-button"
        type="info"
        size="normal "
        round
        plain
        @click="back"
      >
        取消
      </van-button>
      <van-button
        class="guarantee-button submit-btn"
        type="info"
        size="normal "
        round
        @click="saveBqReile"
      >
        提交
      </van-button>
    </template>
  </ac-layout-form>
</template>

<script>
// 表单布局
import acLayoutForm from "@/components/app/layout/form/index.vue";
// 上传文件
import acUploadFile from "@/components/app/continuation-upload-file/index.vue";
import validate from "../../utils/validator/validator";
import vanFieldCheckbox from "@/components/common/vanFieldCheckbox";
import InfoTitle from "../../components/common/InfoTitle";
import Slogan from "@/components/common/slogan";
import {
  sqsclRule,
  cSqxxyy,
  jcxxbqCcxsListRule,
  jcxxbqZjxxListRule,
  jcxxbqXwxxListRule,
} from "../../utils/validator/rules";
import { mbxzts } from "../../utils/consts";
// 创建id
import { createId } from "@/utils/common";
import { getCode } from "@/api/common";
import request from "@/api/axios";
import { mapGetters } from "vuex";
import { Dialog, Notify } from "vant";
import {
  saveXxbqData,
  getXxbqxx,
  getXxbqScclList,
  submitXxbqData,
} from "@/api/guarantee";
import { dateFormat } from "@/utils/dateFormatter";
import { columnsTJR } from "@/utils/option";
import {
  typeCclx,
  typeDbfs,
  typeSddy,
  typeTjrlx,
  typeXwbqsx,
  zjlxType,
} from "@/filters";

export default {
  components: {
    acLayoutForm,
    acUploadFile,
    vanFieldCheckbox,
    InfoTitle,
    Slogan,
  },
  data() {
    return {
      allList: {
        sqs: [],
        qt: [],
        dbl: [],
      },
      // 申请书和其他
      sqsQt: ["sqs", "qt"],
      dbxxzjz: "",
      bqCcxsxxs: [],
      // 证据信息
      bqZjxx: [],
      bqXwxx: [],
      // 担保信息
      bqDbxxs: [],
      // 是否是法院选择页面跳转过来的
      isFormselectBqCourtXx: false,
      showTJRLX: false,
      showSyPicker: false,
      columnTJRLX: columnsTJR,
      nBqlx: "",
      formData: {
        cAh: null,
        cBqid: null,
        cBqId: null,
        cBz: "",
        cId: null,
        cSqxbyy: "",
        cSqxbyyText: "",
        cSqfy: null,
        cSqfymc: null,
        cSqrids: "",
        cSqrmcs: "",
        cSqrxmMultiple: [],
        cTjrsf: "",
        dtCreatetime: "",
        cTjrlxText: "申请人",
        cAhdm: null,
      },
      postData: {
        // 保全id
        cBqid: this.$route.query.bqid,
        cSqr: "",
        cSqsid: "",
        cTjid: "",
        cSqxbyy: "",
        // 申请编号
        cId: this.$route.query.cId,
      },
      sqsclList: [],
      sqsclListDbcl: [],
      sqsclListQtcl: [],
      sqrList: [],
      tjid: "",
      mbxzts: mbxzts,
      // 上传文件url
      // uploadFileUrl: 'ssbq/api/sccls/bgdb/sccl',
      // 删除文件url
      // deleteFileUrl: 'ssbq/api/sccls/bgsq/bg/delsccl',
      // 上传文件url
      uploadFileUrl: "ssbq/api/ssbq/xx/upload",
      // // 删除文件url
      deleteFileUrl: "ssbq/api/ssbq/xx/deletefile",
      // 是否可以渲染
      canRender: false,
      codeList_823000: [],
      saveFlag:false
    };
  },
  computed: {
    ...mapGetters([
      "xxbqxwxxData",
      "xxbqccxsData",
      "xxbqzjxxData",
      "xxbqdbxxData",
    ]),
    // 上传的请求参数
    uploadFileParam() {
      return {
        cllx: 1,
        bqid: this.$route.query.bqid,
        xbid: this.$route.query.cId,
      };
    },
    // 上传的请求参数
    uploadFileParamQtcl() {
      return {
        cllx: 255,
        bqid: this.$route.query.bqid,
        xbid: this.$route.query.cId,
      };
    },
    // uploadFileParamDbcl() {
    //     return {
    //         cllx: 4,
    //         bqid: this.$route.query.bqid,
    //         xbid: this.$route.query.cId,
    //     }
    // },
    // 删除文件的请求参数
    deleteFileParam() {
      return {
        time: new Date().getTime(),
      };
    },
    //担保物名称
    cDbwmc() {
      return (item) => {
        if (item.cDbfs == 5) {
          return `${typeDbfs(item.cDbfs)}-${item.cBxgsmc}`;
        } else if (item.cDbfs == 1) {
          return `${typeDbfs(item.cDbfs)}-保证金`;
        } else if (item.cDbfs == 2) {
          return `${typeDbfs(item.cDbfs)}-${item.cDbwmc}`;
        } else {
          return `${typeDbfs(item.cDbfs)}-${item.dBwmc}`;
        }
      };
    },
  },
  created() {
    this.nBqlx = sessionStorage.getItem("cBqlx");
    this.gainId();
    this.initBqSqrs();
    this.getData();
    getCode({ codetype: 823000 }).then((res) => {
      this["codeList_823000"] = res.data;
    });
  },
  watch: {
    "formData.cSqrxmMultiple"(selectList) {
      if (selectList && selectList.length > 0) {
        this.formData.cSqrids = selectList.join(",");
        this.formData.cSqrmcs = this.sqrList
          .filter((i) => selectList.includes(i.cId))
          .map((mc) => mc.sqrmc)
          .join(",");
      }
    },
  },
  methods: {
    // 上传的请求参数
    uploadFileParamDbcl(dbid) {
      return {
        cllx: 4,
        bqid: this.$route.query.bqid,
        xbid: this.$route.query.cId,
        dbid: dbid,
      };
    },
    /**
     * 获取上传文件数据
     * @returns {Object} 文件数据
     * */
    getUploadFileData(data, fileData) {
      return {
        // 申请材料id
        cId: data.cId,
        ...fileData,
      };
    },
    /**
     * 获取删除文件的参数
     * @param {Object} fileData 文件数据
     * @returns {Object} 请求参数对象
     * */
    getDeleteFileParam(fileData) {
      return {
        // 请求id
        id: fileData.id,
        // 材料类型
        cllx: fileData.cllx,
      };
    },
    // 担保物名称
    dbwmcValue(item) {
      switch (item.cDbfs) {
        case "1":
          return "保证金";
        case "2":
          return item.cDbwmc;
        case "3":
          return typeSddy(item.cCclx);
        case "4":
          return typeSddy(item.cCclx);
        case "5":
          return "诉讼保全责任保险";
      }
    },
    // 担保说明
    dbxxValue(item) {
      if (item.cDbfs === "5") {
        return item.nSysbuy === 1
          ? `${item.cBxgsmc} 保单号：${item.cBdh}`
          : `${item.cBxgsmc}`;
      } else {
        return item.cDbsm || "--";
      }
    },
    params() {
      let formData = JSON.parse(this.formData);
      let xxCcxxs = [];
      let xxXwxxs = [];
      let xxZjxxs = [];
      let xxDbxxs = [];
      xxDbxxs = this.xxbqdbxxData;
      if (this.nBqlx == "1") {
        xxCcxxs = this.xxbqccxsData;
      }
      if (this.nBqlx == "2") {
        xxZjxxs = this.xxbqzjxxData;
      }
      if (this.nBqlx == "3") {
        xxXwxxs = this.xxbqxwxxData;
      }
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      return {
        dbJbxxs: xxDbxxs,
        xbJbxx: formData,
        xbCcxxs: xxCcxxs,
        xbZjxxs: xxZjxxs,
        xbXwxxs: xxXwxxs,
      };
    },
    selectCourtBq() {
      this.$router.push({
        path: "/selectBqCourtXx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    /**
     * 选择事由
     * @returns {void}
     * */
    onSyConfirm: function (code) {
      // 申请解保事由赋值
      this.formData.cSqxbyy = code.code;
      this.formData.cSqxbyyText=code.name;
      // 弹层隐藏
      this.showSyPicker = false;
    },
    /* 操作选择弹层 */
    handlerPicker(name, type) {
      /* 选择保全类型和保全类别需要先提示选择法院 */
      if (
        (name === "showBQLX" ||
          name === "showPicker" ||
          name === "showPickerBxgs") &&
        !this.formData.cFymc
      ) {
        Notify({ type: "danger", message: "请先选择法院" });
        return;
      }

      this[name] = type;
    },
    onConfirmTJRLX(item) {
      // this.formData.cTjrsf = item.text;
      // this.formData.cTjrlx = item.keyId;
      this.formData.cTjrlxText = item.text;
      this.formData.cTjrsf = item.keyId;
      this.showTJRLX = false;
    },
    initForm(res) {
      let data = res.data;
      // 利用es6的结构赋值拿出res.data中需要的数据项并赋给formData
      this.formData = (({
        cAh,
        cBqId,
        cBqid,
        cBz,
        cId,
        cSqxbyy,
        cSqfy,
        cSqfymc,
        cSqrids,
        cSqrmcs,
        cSqrxmMultiple,
        cTjrsf,
        dtCreatetime,
      cAhdm,
      }) => ({
        cAh,
        cBqId,
        cBqid,
        cBz,
        cId,
        cSqxbyy,
        cSqfy,
        cSqfymc,
        cSqrids,
        cSqrmcs,
        cSqrxmMultiple,
        cTjrsf,
        dtCreatetime,
        cAhdm,
      }))(data);
      this.formData.cBqId = this.$route.query.bqid;
      this.formData.cBqid = this.$route.query.bqid;
      this.formData.cId = this.$route.query.cId;
      let _this = this;
      this.codeList_823000.forEach(function (item) {
        if (item.code == _this.formData.cSqxbyy) {
          _this.formData.cSqxbyy = item.code;
          _this.formData.cSqxbyyText=item.name;
        }
      });
      // this.formData.cSqxbyy = this.codeList_823000[0].name;
      if (!this.formData.dtCreatetime) {
        this.formData.dtCreatetime = this.timeFormat(new Date());
      } else {
        this.formData.dtCreatetime = this.timeFormat(
          this.formData.dtCreatetime
        );
      }
      if (this.formData.cSqrmcs) {
        this.formData.cSqrxmMultiple = this.formData.cSqrids.split(",");
      }
      if (!this.formData.cTjrsf) {
        this.formData.cTjrsf = "";
      }
    },
    async getData() {
      // 获取解除保全init接口拿回来的信息
      let xxInitData = JSON.parse(sessionStorage.getItem("xxInitData"));
      if (xxInitData) {
        this.initForm(xxInitData);
      } else {
        getXxbqScclList({ xbid: this.$route.query.cId }).then((res) => {
          console.log(res.data);
          this.sqsclList = res.data.sqs;
          this.sqsclListDbcl = res.data.dbl;
          this.sqsclListQtcl = res.data.qt;
          console.log("22222222=========", this.sqsclListDbcl);
        });
        // 获取解除保全基本信息
        await getXxbqxx({ id: this.$route.query.cId || "" })
          .then((res) => {
            this.initForm(res);
            let xxcheckedFy = sessionStorage.getItem("xxcheckedFy");
            if (xxcheckedFy && this.isFormselectBqCourtXx) {
              this.formData.cSqfymc = xxcheckedFy;
            }
            this.formData.cTjrlxText = typeTjrlx(this.formData.cTjrsf);
            this.formData.dtCreatetime = this.timeFormat(
              this.formData.dtCreatetime
            );
            console.log("获取基本信息", res.data);
            // Object.assign(this.jcbqjbxxData, res.data)
            // 获取担保基本信息列表
            this.$store
              .dispatch("GetXXBQDBXXList", {
                xbid: this.$route.query.cId,
                bqid: this.$route.query.bqid,
              })
              .then((res) => {
                this.getBqDbxx(res.data);
                this.updateDbzjz(res.data);
              });
            let cBqlx = sessionStorage.getItem("cBqlx");
            if (cBqlx == "1") {
              this.$store
                .dispatch("GetXXBQCCXSList", {
                  xbid: this.$route.query.cId,
                  bqid: this.$route.query.bqid,
                })
                .then((res) => {
                  // this.bqCcxsxxs = res.data;
                  this.getBqCcxs(res.data);
                  console.log("this.bqCcxsxxs===============", this.bqCcxsxxs);
                });
            } else if (cBqlx == "2") {
              this.$store
                .dispatch("GetXXBQZJXXList", {
                  xbid: this.$route.query.cId,
                  bqid: this.$route.query.bqid,
                })
                .then((res) => {
                  this.getBqZjxx(res.data);
                });
            } else if (cBqlx == "3") {
              this.$store
                .dispatch("GetXXBQXWXXList", {
                  xbid: this.$route.query.cId,
                  bqid: this.$route.query.bqid,
                })
                .then((res) => {
                  this.getBqXwxx(res.data);
                });
            }
          })
          .catch((error) => console.log(error));
      }
    },
    deleteBqCCXS: function (id, index) {
      this.bqCcxsxxs.splice(index, 1);
      console.log(this.bqCcxsxxs);
      this.xxbqccxsData.map((item, index) => {
        if (item.cId == id) this.xxbqccxsData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
      });
      console.log(this.xxbqccxsData);
    },
    deleteBqXwxx: function (id, index) {
      this.bqXwxx.splice(index, 1);
      this.xxbqxwxxData.map((item, index) => {
        if (item.cid == id) this.xxbqxwxxData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
      });
    },
    timeFormat(currentTime) {
      // 时间格式化 2019-09-08
      let time = new Date(currentTime);
      let year = time.getFullYear();
      let month = this.showTime(time.getMonth() + 1);
      let day = this.showTime(time.getDate());
      return year + "-" + month + "-" + day;
    },
    // 封装一个不够两位数就补零的函数
    showTime(t) {
      let time;
      time = t >= 10 ? t : "0" + t;
      return time;
    },
    /**
     * 更新担保信息中担保总价值变化
     * @returns {void}
     * */
    updateDbzjz(datalist) {
      let zjz = 0;
      datalist.forEach((item) => {
        zjz += Number(item.nDbjz * 100);
        item.dBwmc = typeSddy(item.dBwmc);
      });
      this.dbxxzjz = "担保总价值：" + (zjz / 100).toFixed(2) + "元";
    },
    deleteBqDbxx(id, index) {
      // 删除
      Dialog.confirm({
        title: "提示",
        message: "删除担保信息后，对应的担保材料会一并删除, 确认删除吗?",
        confirmButtonColor: "#fff",
        cancelButtonColor: "#fff",
      })
        .then(() => {
          this.bqDbxxs.splice(index, 1);
          this.xxbqdbxxData.map((item, index) => {
            if (item.cId == id) this.xxbqdbxxData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
            console.log("333333333333333333333", this.xxbqdbxxData);
          });
          this.updateDbzjz(this.xxbqdbxxData);
          // 删除担保信息级联删除担保材料
          this.sqsclListDbcl.map((item, index) => {
            if (item.dbid == id) {
              item.clList = [];
              this.sqsclListDbcl.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    // 删除证据信息
    deleteBqZjxx: function (id, index) {
      // debugger
      this.bqZjxx.splice(index, 1);
      this.xxbqzjxxData.map((item, index) => {
        if (item.cid == id) this.xxbqzjxxData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
      });
    },
    getBqCcxs(ccxsdata) {
      ccxsdata.map((item) => {
        this.bqCcxsxxs.push({
          cId: item.cId,
          cCclx: item.cCclx,
          cCclxText: typeCclx(item.cCclx),
          cMs: item.cMs,
          dBqksrq: item.dBqksrq,
          dBqjsrq: item.dBqjsrq,
        });
      });
    },
    getBqXwxx(xwxxdata) {
      xwxxdata.map((item) => {
        this.bqXwxx.push({
          cId: item.cid,
          nXwbqsx: item.nXwbqsx,
          nXwbqsxTxt: typeXwbqsx(item.nXwbqsx),
          cSm: item.cSm,
          dBqksrq: item.dBqksrq,
          dBqjsrq: item.dBqjsrq,
        });
      });
    },
    getBqDbxx(dbxxdata) {
      console.log("担保信息==========", dbxxdata);
      dbxxdata.map((item) => {
        this.bqDbxxs.push({
          isAdd: item.isAdd,
          /**
           * 公共字段
           */
          cId: item.cId,
          type: typeDbfs(item.cDbfs),
          name: this.dbwmcValue(item),
          cDbsm: this.dbxxValue(item),
          nDbjz: Number(item.nDbjz) ? Number(item.nDbjz).toFixed(2) : "--",
          cDbxxId: item.cDbxxId,
          cSzxid: item.cSzxid,
          cDbfs: item.cDbfs,
          cOldDbfs: item.cOldDbfs,
          cDbfsText: typeDbfs(item.cDbfs),
          nSysbuy: item.nSysbuy,
          nOldSysbuy: item.nOldSysbuy,
          cDbr: item.cDbr,
          // nDbjz: item.nDbjz,
          // cDbsm: item.cDbsm,
          cDbwmc: item.cDbwmc,
          cCclx: item.cCclx,
          cCclxText: typeCclx(item.cCclx),
          cBxgs: item.cBxgs,
          cBxgsmc: item.cBxgsmc,
          cBdh: item.cBdh,
          cLy: item.cLy,
        });
      });
    },
    getBqZjxx(zjxxdata) {
      zjxxdata.map((item) => {
        this.bqZjxx.push({
          cId: item.cid,
          // 证据类型
          nzjlx: item.nzjlx,
          // nZjlx: zjlxType(item.nZjlx),
          // 证据类型
          nZjlxTxt: zjlxType(item.nzjlx),
          // 证据名称
          czjmc: item.czjmc,
          // 原件原物
          nyjwj: item.nyjwj,
          // 证据来源
          czjly: item.czjly,
          // 证据说明
          cSm: item.cSm,
          dBqksrq: item.dBqksrq,
          dBqjsrq: item.dBqjsrq,
        });
      });
    },
    // 添加财产线索
    addBqCcxs() {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("xxInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      // debugger
      console.log("111111111========", this.formData);
      // JSON.stringify转字符串,值为undefined被过滤处理的问题
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log("222222========", formData.dtCreatetime);
      sessionStorage.setItem("xxbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("bqCcxsId", "");
      this.onSubmit();
      this.$router.push({
        path: "/XxaddBqCcxs",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 添加证据信息
    addBqZjxx() {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("xxInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      // debugger
      console.log("111111111========", this.formData);
      // JSON.stringify转字符串,值为undefined被过滤处理的问题
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      // sessionStorage.setItem("xxbqzjxx", this.formData);
      sessionStorage.setItem("xxbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("bqZjxxId", "");
      this.onSubmit();
      this.$router.push({
        path: "/XxaddBqZjxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 财产线索
    goToAddBqCCXS: function (ccxsItem, ccxsId) {
      sessionStorage.setItem("xxccxsItem", JSON.stringify(ccxsItem));
      sessionStorage.setItem("bqCcxsId", ccxsId);
      this.$router.push({
        path: "/XxaddBqCCXS",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 行为信息
    goToAddBqXwxx: function (xwxxItem, cId) {
      sessionStorage.setItem("xxxwxxItem", JSON.stringify(xwxxItem));
      sessionStorage.setItem("bqXwxxId", cId);
      this.$router.push({
        path: "/XxaddBqXwxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 担保信息信息
    goToEditBqDbxx: function (dbxxItem, cId) {
      sessionStorage.setItem("xxdbxxItem", JSON.stringify(dbxxItem));
      sessionStorage.setItem("cDbxxId", cId);
      this.$router.push({
        path: "/XxaddBqDbxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 证据信息
    goToAddBqZjxx: function (zjxxItem, cid) {
      sessionStorage.setItem("xxzjxxItem", JSON.stringify(zjxxItem));
      sessionStorage.setItem("bqZjxxId", cid);
      this.$router.push({
        path: "/XxaddBqZjxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },

    onSubmit(fn) {
      console.log("dbx===========", this.params());
      saveXxbqData(this.params())
        .then((res) => {
          console.log("--addXcxXw 123", res);
          if (res.code === 200) {
            this.$notify({ type: "success", message: "操作成功" });
          } else {
            this.$notify(res.message);
          }
          fn();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 行为信息
    addBqXwxx() {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("xxInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      // debugger
      console.log("111111111========", this.formData);
      // JSON.stringify转字符串,值为undefined被过滤处理的问题
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log("222222========", formData.dtCreatetime);
      sessionStorage.setItem("xxbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("bqXwxxId", "");
      this.onSubmit();
      this.$router.push({
        path: "/XxaddBqXwxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    addBqDbxx: function () {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("xxInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log("222222========", formData.dtCreatetime);
      sessionStorage.setItem("xxbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("cDbxxId", "");
      this.onSubmit();
      this.$router.push({
        path: "/XxaddBqDbxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },

    /**
     * 保存
     * */
    saveBqReile() {
      // 校验表单
      // this.validateForm().then(() => {
      //     // this.postData.cSqxxyy = this.formData.cSqxxyy;
      //     // this.$axios.post('ssbq/api/bqsq/xx/tj?bqid=' + this.postData.cBqid, this.postData)
      //     //     .then(res => {
      //     //         if (res.code === 200) {
      //     //             this.$notify({'type': 'success', 'message': '申请续行提交成功'});
      //     //             history.go(-1);
      //     //         } else {
      //     //             this.$notify(res.message);
      //     //         }
      //     //     })
      //     //     .catch(() => {
      //     //         this.$notify("系统异常");
      //     //     })
      // }).catch(error => {
      //     console.log(error);
      // });
      // 校验表单
      this.validateForm().then(() => {


        console.log("zxfwtoken========", localStorage.getItem('zxfwtoken'));
            if (localStorage.getItem('zxfwtoken')) {
              const paramsah = {
                fydm: this.formData.cSqfy,
                ah: this.formData.cAh,
                zxfwToken: localStorage.getItem('zxfwtoken')
              };
              this.$axios.get('ssbq/api/bqyzw/bqsq/ahdm', paramsah).then((res) => {
                if (res.code === 200) {
                  this.formData.cAhdm = res.data;
                  console.log('——————this.cAhdm：————————', this.formData.cAhdm);
                  this.saveFlag=true;
                } else {
                  const errorMessage ='案号代码获取失败,请重新尝试';
                  this.$notify(errorMessage);
                  this.saveFlag=false;
                }
              });
            } else {
              const errorMessage= '案号代码获取失败,请重新尝试';
              this.$notify(errorMessage);
              this.saveFlag=false;
            };

            if(this.saveFlag){
        this.formData = JSON.stringify(this.formData, (key, value) =>
          // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
          typeof value === "undefined" ? "" : value
        );
        let formData = JSON.parse(this.formData);
        formData.dtCreatetime = this.currentDate;
        formData.dtCreatetime = dateFormat(
          formData.dtCreatetime,
          "yyyy-MM-dd hh:mm:ss"
        );
        console.log("222222========", formData.dtCreatetime);

       // this.onSubmit();
       //  if (localStorage.getItem('zxfwtoken')) {
       //    const paramsah = {
       //      fydm: formData.cSqfy,
       //      ah: formData.cAh,
       //      zxfwToken: localStorage.getItem('zxfwtoken')
       //    };
       //    this.$axios.get('ssbq/api/bqyzw/bqsq/ahdm', paramsah).then((res) => {
       //      if (res.code === 200) {
       //        this.formData.cAhdm = res.data;
       //        console.log('——————this.cAhdm：————————',  this.formData.cAhdm);
               //this.params.xbJbxx.cAhdm = formData.cAhdm;
              //暂存后提交
              saveXxbqData(this.params())
                  .then((res) => {
                    console.log("--addXcxXw 123", res);
                    if (res.code === 200) {
                      this.$notify({ type: "success", message: "操作成功" });
                      // 申请续保事由
                      this.postData.cSqxbyy = this.formData.cSqxbyy;
                      // 提交（先暂存再提交）
                      submitXxbqData({ xbid: this.$route.query.cId }).then((res) => {
                        if (res.code == 200) {
                          this.$router.push("/home/myContinuationPreservation");
                        } else {
                          this.$message({
                            type: "warning",
                            message: res.message,
                          });
                        }
                      });
                    } else {
                      this.$notify(res.message);
                    }
                    fn();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
            }

      });
    },

    /**
     * 关联id
     * */
    gainId() {
      let currentBqid = this.$route.query.bqid;
      let currentcId = this.$route.query.cId;
      this.postData.cBqid = currentBqid;
      this.postData.cId = currentcId;
      createId()
        .then((id) => {
          this.tjid = id;
          this.postData.cTjid = id;
        })
        .catch(() => {
          this.$notify("系统异常");
        });
    },

    /**
     * 初始化申请人
     * @returns {void}
     * */
    initBqSqrs() {
      this.$axios
        .get("ssbq/api/sqrs?bqid=" + this.postData.cBqid)
        .then((res) => {
          if (res.code == 200) {
            let sqrs = "";
            let sqrIds = "";
            res.data.forEach((item) => {
              let sqr = {};

              if (item.cSqrlx == "1") {
                sqr.sqrmc = item.cSqrxm;
                sqr.cId = item.cZjh;
              } else {
                sqr.sqrmc = item.cQymc;
                sqr.cId = item.cQyzzjgdm;
              }
              sqrs = sqrs.concat(sqr.sqrmc, "、");
              sqrIds = sqrIds.concat(sqr.cId, ",");
              this.sqrList.push(sqr);
            });
            this.formData.cSqr = sqrs.substring(0, sqrs.length - 1);
            this.postData.cSqr = sqrIds.substring(0, sqrIds.length - 1);
          } else {
            this.$notify(res.message);
          }
        })
        .catch(function () {
          this.$notify("系统异常");
        });
    },

    // /**
    //  * 请求删除申请材料
    //  * @param {Object} params 请求参数
    //  * @returns {Promise}
    //  * */
    // requestDelSccl(params) {
    //     return request({
    //         url:'ssbq/api/sccls/bgsq/delsqcl',
    //         method:'delete',
    //         params: {
    //             time: new Date().getTime(),
    //             ...params
    //         }
    //     })
    // },

    /**
     * 返回
     * */
    back() {
      history.go(-1);
      return;
      // // 如果没有上传材料，直接返回
      // if (!this.sqsclList.length && !this.sqsclListDbcl.length && !this.sqsclListQtcl.length) {
      //     // 直接返回
      //     history.go(-1);
      //     return;
      // }
      // // 删除上传材料再返回
      // this.delXxbqSccl({
      //     cDbid: '',
      //     isDeldbl: false,
      //     isDelsqs: false,
      //     // 变更id
      //     cBgid: this.tjid,
      // }).then(() => {
      //     history.go(-1);
      // }).catch(() => {
      //     this.$notify("系统异常");
      // });
    },
    downloadTemplate() {
      window.open("wsbq/ssbq/api/wjgl/tempdownload/" + 7);
    },

    /**
     * 验证表单
     * @returns {Promise}
     * */
    validateForm() {
      console.log("=============", this.formData);
      var descriptor = {
        // 续行申请原因
        cSqxbyy: cSqxxyy,
        // 续行申请书
        sqs: sqsclRule,
        ccxslist: this.nBqlx == "1" ? jcxxbqCcxsListRule : "",
        zjxxlist: this.nBqlx == "2" ? jcxxbqZjxxListRule : "",
        xwxxlit: this.nBqlx == "3" ? jcxxbqXwxxListRule : "",
      }; // 校验表单数据
      const validated = validate(descriptor, {
        cSqxbyy: this.formData.cSqxbyy,
        sqs: this.sqsclList,
        ccxslist: this.nBqlx == "1" ? this.bqCcxsxxs : "",
        zjxxlist: this.nBqlx == "2" ? this.bqZjxx : "",
        xwxxlit: this.nBqlx == "3" ? this.bqXwxx : "",
      });
      return validated;
    },
    // 上传验证
    beforeRead(file) {
      if (file.size == 0) {
        Notify("上传文件必须大于0kb!");
      }
      let fileType = "image/jpeg||image/jpg||image/bmp||image/gif||image/png";
      let imgFormat = "jpg、png、jpeg、bmp、gif";
      if (fileType.indexOf(file.type) === -1) {
        Notify({
          message: `仅支持格式为${imgFormat}的图片!`,
          type: "danger",
          duration: 5 * 1000,
        });
        return false;
      } else if (file.size > 20 * 1024 * 1024) {
        Notify("上传文件大小不能超过20MB!");
        return false;
      }
      return true;
    },
  },
  //进入该页面时，刷新页面，要不上传会导致页面刷新
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "myPreservation") {
        // 如果是从保全列表过来的需要刷新下页面，否则在手机上上传会有问题
        window.location.reload();
      }
      let xxcheckedFy = sessionStorage.getItem("xxcheckedFy");
      if (from.name == "selectBqCourtXx" && xxcheckedFy) {
        vm.$data.isFormselectBqCourtXx = true;
        vm.$data.formData.cSqfymc = xxcheckedFy;
      }
      // 可以进行渲染
      vm.canRender = true;
    });
  },
};
</script>
<style lang="less" scoped>
.delete-btn {
  width: 64px;
  height: 55px;
  background: #ee0a24;
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  letter-spacing: 3px;
  text-align: center;
}
</style>
